export const COUNTIES = [
  { title: 'Antrim', value: 'Antrim' },
  { title: 'Armagh', value: 'Armagh' },
  { title: 'Carlow', value: 'Carlow' },
  { title: 'Cavan', value: 'Cavan' },
  { title: 'Clare', value: 'Clare' },
  { title: 'Cork', value: 'Cork' },
  { title: 'Derry', value: 'Derry' },
  { title: 'Donegal', value: 'Donegal' },
  { title: 'Down', value: 'Down' },
  { title: 'Dublin', value: 'Dublin' },
  { title: 'Fermanagh', value: 'Fermanagh' },
  { title: 'Galway', value: 'Galway' },
  { title: 'Kerry', value: 'Kerry' },
  { title: 'Kildare', value: 'Kildare' },
  { title: 'Kilkenny', value: 'Kilkenny' },
  { title: 'Laois', value: 'Laois' },
  { title: 'Leitrim', value: 'Leitrim' },
  { title: 'Limerick', value: 'Limerick' },
  { title: 'Longford', value: 'Longford' },
  { title: 'Louth', value: 'Louth' },
  { title: 'Mayo', value: 'Mayo' },
  { title: 'Meath', value: 'Meath' },
  { title: 'Monaghan', value: 'Monaghan' },
  { title: 'Offaly', value: 'Offaly' },
  { title: 'Roscommon', value: 'Roscommon' },
  { title: 'Sligo', value: 'Sligo' },
  { title: 'Tipperary', value: 'Tipperary' },
  { title: 'Tyrone', value: 'Tyrone' },
  { title: 'Waterford', value: 'Waterford' },
  { title: 'Westmeath', value: 'Westmeath' },
  { title: 'Wexford', value: 'Wexford' },
  { title: 'Wicklow', value: 'Wicklow' }
];


export const REGULAR_CONSTRAINST = {
  title: {
    presence: true,
    length: {
      minimum: 1,
      maximum: 200,
      tooShort: 'is required',
      tooLong: 'maximum 200 symbols'
    }
  },
  summary: {
    length: {
      minimum: 1,
      maximum: 200,
      tooShort: 'is required',
      tooLong: 'maximum 200 symbols'
    }
  },
  provider_bio: {
    length: {
      maximum: 1000,
      tooLong: 'maximum 1000 symbols'
    }
  },
  host: {
    length: {
      maximum: 200,
      tooLong: 'maximum 200 symbols'
    }
  },
  contact_email: {
    email: true
  },
  provided_by: {
    presence: true
  },
  how_many_hours: {
    numericality: true
  },

  contact_phone: {
    numericality: true
  },
  venue_county: {
    presence: true
  },
  venue_address: {
    presence: true,
    length: {
      maximum: 500,
      tooLong: 'maximum 500 symbols'
    }
  },
  venue_name: {
    presence: true,
    length: {
      maximum: 200,
      tooLong: 'maximum 200 symbols'
    }
  },
  end_date: {
    presence: true
  },

  start_date: {
    presence: true
  }
};

export const MODULE_VALIDATION = {
  title: {
    presence: { message: "Module title must be specified" },
    length: {
      maximum: 200,
      tooLong: "There are only 200 characters allowed"
    }
  },
  details: {
    length: {
      maximum: 50000,
      tooLong: "There are only 50,000 characters allowed"
    },
    presence: { message: "Module description must be specified" }
  }
};

export const QUESTION_CONSTRAINS = {
  text: {
    length: {
      maximum: 20000,
      tooLong: "There are only 20000 characters allowed"
    },
    presence: { message: "Question can't be blank" }
  }
};

export const QUIZ_CONSTRAINS = {
  text: {
    length: {
      maximum: 20000,
      tooLong: "There are only 20000 characters allowed"
    },
    presence: {
      message: "Please ensure all quiz questions are specified for Module "
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/create_regular_workshop/constants.js